import { Injectable, computed, signal } from '@angular/core';
import type { GridPlugin } from '../interfaces/grid-context.types';

/** Registro dos plugins ativos na instância atual do grid (não confundir com o Registry de renderers). */
@Injectable()
export class GridPluginManager {
  private readonly _plugins = signal<ReadonlyMap<string, GridPlugin>>(new Map());

  readonly activePluginIds = computed(() => Array.from(this._plugins().keys()));

  register(plugin: GridPlugin): void {
    const next = new Map(this._plugins());
    next.set(plugin.pluginId, plugin);
    this._plugins.set(next);
  }

  unregister(pluginId: string): void {
    const next = new Map(this._plugins());
    if (next.delete(pluginId)) this._plugins.set(next);
  }

  get<P extends GridPlugin>(pluginId: string): P | undefined {
    return this._plugins().get(pluginId) as P | undefined;
  }
}
